import React from "react";
import
    {
        AppBar,
        Box,
        Card,
        CardContent,
        Divider,
        Grid,
        Paper,
        Table,
        TableBody,
        TableCell,
        TableContainer,
        TableHead,
        TableRow,
        Typography,
        // Typography,
        // Typography,
    } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Title from "../../sharedcomponents/title/title";

const useStyles = makeStyles(() => ({
    cardContent: {
        padding: 0,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    fontWeight500: {
        fontWeight: 500
    },
    fontWeight600: {
        fontWeight: 600
    },
    textCenter: {
        textAlign: 'center'
    }
}));
const appBarStyle = {
    mb: 1,
    boxShadow: 'none',
    pt: 1,
    pb: 1,
    pl: 1,
    borderTop: '1px solid #D7D7D7',
    borderBottom: '1px solid #D7D7D7',
    backgroundColor: '#F8F8F8',
};
const AllStarTicketAccordianCard = (props) =>
{
    const classess = useStyles();
    const { item } = props;
    const accordianInfo = item.actualData.ticketAllStars;
    let ticketJsonData = []
    const logoURL = process.env.REACT_APP_CREDIT_LOGOS;
    if (item.actualData?.ticketAllStarSetting.setting?.length > 0)
    {
        const jsonP = JSON.parse(item.actualData.ticketAllStarSetting.setting);
        if (jsonP.length > 0)
        {
            ticketJsonData.push(JSON.parse(jsonP[0].TicketSetting))
        }
    }
    // console.log("ticketAllStarSetting", ticketJsonData);

    return (
        <>
            <Divider sx={{ mb: 1 }} />
            <Card sx={{ boxShadow: "none" }} >
                <AppBar position="static" color="default" sx={appBarStyle}>
                    <Title
                        title={'Complimentary Tickets'}
                        // addicon="land"
                        sx={{
                            ml: 1,
                            textAlign: "center"
                        }}
                    />
                </AppBar>
                <CardContent className={classess.cardContent} sx={{ fontSize: '11px' }}>
                    <Grid container>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table" size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">Friday Night</TableCell>
                                        <TableCell align="center">Saturday Night</TableCell>
                                        <TableCell align="center">Sunday Night</TableCell>
                                        <TableCell align="center">Contact Details</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow >
                                        <TableCell width="23%" align="center">
                                            <><Box component="span" className={classess.fontWeight500}>{ticketJsonData[0].ticketFriCompCount}</Box><br /></>
                                        </TableCell>
                                        <TableCell width="23%" align="center">
                                            <><Box component="span" className={classess.fontWeight500}>{ticketJsonData[0].ticketSatCompCount}</Box><br /></>
                                        </TableCell>
                                        <TableCell width="23%" align="center">
                                            <><Box component="span" className={classess.fontWeight500}>{ticketJsonData[0].ticketSunCompCount}</Box><br /></>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Box display={'flex'} justifyItems={'left'} alignItems={'left'}>
                                                <Typography
                                                    variant="h4"
                                                    flexGrow={1}
                                                    fontSize={12}
                                                    fontWeight={500}>
                                                    Name
                                                    <Typography
                                                        fontSize={11}
                                                        sx={{
                                                            wordBreak: 'break-word',
                                                        }}>
                                                        {item.actualData.contactName}
                                                    </Typography>
                                                </Typography>
                                                <Typography
                                                    variant="h4"
                                                    flexGrow={1}
                                                    fontSize={12}
                                                    fontWeight={500}>
                                                    Email
                                                    <Typography
                                                        fontSize={11}
                                                        sx={{
                                                            wordBreak: 'break-word',
                                                        }}>
                                                        <a
                                                            href={`mailto:${item.actualData.contactEmail}`}>
                                                            {' '}
                                                            {item.actualData.contactEmail}{' '}
                                                        </a>
                                                    </Typography>
                                                </Typography>
                                                <Typography
                                                    variant="h4"
                                                    flexGrow={1}
                                                    fontSize={12}
                                                    fontWeight={500}>
                                                    Phone
                                                    <Typography
                                                        fontSize={11}
                                                        sx={{
                                                            wordBreak: 'break-word',
                                                        }}>
                                                        {item.actualData.contactNo}{' '}
                                                    </Typography>
                                                </Typography>
                                                <Divider />
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>

                            </Table>
                        </TableContainer>
                    </Grid>
                </CardContent>
                <AppBar position="static" color="default" sx={appBarStyle}>
                    <Title
                        title={'Purchase Tickets'}
                        // addicon="land"
                        sx={{
                            ml: 1,
                            textAlign: "center"
                        }}
                    />
                </AppBar>
                <CardContent className={classess.cardContent} sx={{ fontSize: '11px' }}>
                    <Grid container>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table" size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">Friday Night</TableCell>
                                        <TableCell align="center">Saturday Night</TableCell>
                                        <TableCell align="center">Sunday Night</TableCell>
                                        <TableCell align="center">Card Info</TableCell>
                                        <TableCell align="center">Contact Details</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {accordianInfo.map((val, j) =>
                                    {
                                        if (val.ticketAllStarDetails.length > 0)
                                        {
                                            return (<TableRow key={j}>
                                                <TableCell width="17%" align="center">
                                                    {val.ticketAllStarDetails.map((data, i) =>
                                                    {
                                                        // console.log("data",data);
                                                        if (data.ticketNightID === 1 && data.ticketCount > 0)
                                                        {
                                                            return (<><Box key={i} component="span" className={classess.fontWeight500}>{data.subTypeName} (${data.price}) - {data.ticketCount}</Box><br /></>)
                                                        }
                                                    })}
                                                </TableCell>
                                                <TableCell width="17%" align="center">
                                                    {val.ticketAllStarDetails.map((data, i) =>
                                                    {
                                                        if (data.ticketNightID === 2 && data.ticketCount > 0)
                                                        {
                                                            return (<><Box key={i} component="span" className={classess.fontWeight500}>{data.subTypeName} (${data.price}) - {data.ticketCount}</Box><br /></>)
                                                        }
                                                    })}
                                                </TableCell>
                                                <TableCell width="17%" align="center">
                                                    {val.ticketAllStarDetails.map((data, i) =>
                                                    {
                                                        if (data.ticketNightID === 3  && data.ticketCount > 0)
                                                        {
                                                            return (<><Box key={i} component="span" className={classess.fontWeight500}>{data.subTypeName} (${data.price}) - {data.ticketCount}</Box><br /></>)
                                                        }
                                                    })}</TableCell>
                                                <TableCell width="17%" align="left">
                                                    <Box component='span'>
                                                        <img src={`${logoURL}${val.brand}.svg`} width='24' height={16} style={{ border: '1px solid #ccc', borderRadius: 4, marginRight: '8px' }} />{`****-${val.summary} - ${val.cardName}`}
                                                    </Box>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Box key={j} display={'flex'} justifyItems={'left'} alignItems={'left'}>
                                                        <Typography
                                                            variant="h4"
                                                            flexGrow={1}
                                                            fontSize={12}
                                                            fontWeight={500}>
                                                            Name
                                                            <Typography
                                                                fontSize={11}
                                                                sx={{
                                                                    wordBreak: 'break-word',
                                                                }}>
                                                                {item.actualData.contactName}
                                                            </Typography>
                                                        </Typography>
                                                        <Typography
                                                            variant="h4"
                                                            flexGrow={1}
                                                            fontSize={12}
                                                            fontWeight={500}>
                                                            Email
                                                            <Typography
                                                                fontSize={11}
                                                                sx={{
                                                                    wordBreak: 'break-word',
                                                                }}>
                                                                <a
                                                                    href={`mailto:${item.actualData.contactEmail}`}>
                                                                    {' '}
                                                                    {item.actualData.contactEmail}{' '}
                                                                </a>
                                                            </Typography>
                                                        </Typography>
                                                        <Typography
                                                            variant="h4"
                                                            flexGrow={1}
                                                            fontSize={12}
                                                            fontWeight={500}>
                                                            Phone
                                                            <Typography
                                                                fontSize={11}
                                                                sx={{
                                                                    wordBreak: 'break-word',
                                                                }}>
                                                                {item.actualData.contactNo}{' '}
                                                            </Typography>
                                                        </Typography>
                                                        <Divider />
                                                    </Box>
                                                </TableCell>
                                            </TableRow>)
                                        }
                                    })}
                                </TableBody>

                            </Table>
                        </TableContainer>
                    </Grid>
                </CardContent>
                <AppBar position="static" color="default" sx={appBarStyle}>
                    <Title
                        title={'Additional Purchase Tickets'}
                        // addicon="land"
                        sx={{
                            ml: 1,
                            textAlign: "center"
                        }}
                    />
                </AppBar>
                <CardContent className={classess.cardContent}>
                    <Grid container>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table" size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">Friday Night</TableCell>
                                        <TableCell align="center">Saturday Night</TableCell>
                                        <TableCell align="center">Sunday Night</TableCell>
                                        <TableCell align="center">Card Info</TableCell>
                                        <TableCell align="center">Contact Details</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {accordianInfo.map((val, j) =>
                                    {
                                        if (val.ticketAllStarAdditionalPurchase.length > 0)
                                        {
                                            return (<TableRow key={j}>
                                                <TableCell width="17%" align="center">
                                                    {val.ticketAllStarAdditionalPurchase.map((data, i) =>
                                                    {
                                                        if (data.ticketNightID === 1 && data.ticketCount > 0)
                                                        {
                                                            return (<><Box key={i} component="span" className={classess.fontWeight500}>{data.subTypeName} (${data.price}) - {data.ticketCount}</Box><br /></>)
                                                        }
                                                    })}
                                                </TableCell>
                                                <TableCell width="17%" align="center">
                                                    {val.ticketAllStarAdditionalPurchase.map((data, i) =>
                                                    {
                                                        if (data.ticketNightID === 2 && data.ticketCount > 0)
                                                        {
                                                            return (<><Box key={i} component="span" className={classess.fontWeight500}>{data.subTypeName} (${data.price}) - {data.ticketCount}</Box><br /></>)
                                                        }
                                                    })}
                                                </TableCell>
                                                <TableCell width="17%" align="center">
                                                    {val.ticketAllStarAdditionalPurchase.map((data, i) =>
                                                    {
                                                        if (data.ticketNightID === 3 && data.ticketCount > 0)
                                                        {
                                                            return (<><Box key={i} component="span" className={classess.fontWeight500}>{data.subTypeName} (${data.price}) - {data.ticketCount}</Box><br /></>)
                                                        }
                                                    })}</TableCell>
                                                <TableCell width="17%" align="left">
                                                    <Box component='span'>
                                                        <img src={`${logoURL}${val.brand}.svg`} width='24' height={16} style={{ border: '1px solid #ccc', borderRadius: 4, marginRight: '8px' }} />{`****-${val.summary} - ${val.cardName}`}
                                                    </Box>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <Box key={j} display={'flex'} justifyItems={'left'} alignItems={'left'}>
                                                        <Typography
                                                            variant="h4"
                                                            flexGrow={1}
                                                            fontSize={12}
                                                            fontWeight={500}>
                                                            Name
                                                            <Typography
                                                                fontSize={11}
                                                                sx={{
                                                                    wordBreak: 'break-word',
                                                                }}>
                                                                {item.actualData.contactName}
                                                            </Typography>
                                                        </Typography>
                                                        <Typography
                                                            variant="h4"
                                                            flexGrow={1}
                                                            fontSize={12}
                                                            fontWeight={500}>
                                                            Email
                                                            <Typography
                                                                fontSize={11}
                                                                sx={{
                                                                    wordBreak: 'break-word',
                                                                }}>
                                                                <a
                                                                    href={`mailto:${item.actualData.contactEmail}`}>
                                                                    {' '}
                                                                    {item.actualData.contactEmail}{' '}
                                                                </a>
                                                            </Typography>
                                                        </Typography>
                                                        <Typography
                                                            variant="h4"
                                                            flexGrow={1}
                                                            fontSize={12}
                                                            fontWeight={500}>
                                                            Phone
                                                            <Typography
                                                                fontSize={11}
                                                                sx={{
                                                                    wordBreak: 'break-word',
                                                                }}>
                                                                {item.actualData.contactNo}{' '}
                                                            </Typography>
                                                        </Typography>
                                                        <Divider />
                                                    </Box>
                                                </TableCell>
                                            </TableRow>)
                                        }
                                    })}
                                </TableBody>

                            </Table>
                        </TableContainer>
                    </Grid>
                </CardContent>
            </Card>
        </>
    )
}

export default AllStarTicketAccordianCard;